import api from '@/api/reports';
import filters from './filters';

const namespaced = true;

export const mutations = {
  SET_OVERVIEW_REPORT(state, { overview }) {
    state.overview = overview;
  },
  SET_PROFICIENCY_REPORT(state, { proficiency }) {
    state.proficiency = proficiency;
  },
};

export const actions = {
  FETCH_OVERVIEW_REPORT: ({ commit, state, rootGetters }) => {
    return new Promise(resolve => {
      api
        .fetchOrganizationOverview({
          organizationId: rootGetters.organizationId,
          filters: JSON.parse(JSON.stringify(state.filters)),
        })
        .then(response => {
          const overview = response.results[0];

          commit('SET_OVERVIEW_REPORT', { overview });
          resolve(overview);
        });
    });
  },

  FETCH_PROFICIENCY_REPORT: ({ commit, state, rootGetters }) => {
    return new Promise(resolve => {
      api
        .fetchOrganizationProficiency({
          organizationId: rootGetters.organizationId,
          filters: JSON.parse(JSON.stringify(state.filters)),
        })
        .then(response => {
          const proficiency = response.results;

          commit('SET_PROFICIENCY_REPORT', { proficiency });
          resolve(proficiency);
        });
    });
  },
};

const state = {
  overview: null,
  proficiency: null,
};

export default {
  namespaced,
  state,
  actions,
  mutations,
  modules: {
    filters,
  },
};
